import { render, staticRenderFns } from "./CustomerSearchComponent.vue?vue&type=template&id=1294076b&scoped=true&"
import script from "./CustomerSearchComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294076b",
  null
  
)

export default component.exports